import axios from "axios";

import { API_URL } from "../constants";
import { getToken } from "./tokenStorage";

// Attach the customer session token (when present) to requests aimed at
// OUR API only — never to other hosts (e.g. S3), so the token can't leak
// cross-origin. Public API endpoints ignore it; only /auth/me* reads it.
axios.interceptors.request.use((config) => {
  try {
    const url = config.url || "";
    const token = getToken();
    // Origin-boundary check (not a bare prefix): a prefix match would also
    // attach the token to e.g. `https://api.pxnres.com.evil.com/…`. Compare
    // resolved origins so the token only ever goes to OUR API.
    let sameApiOrigin = false;
    if (token && typeof url === "string") {
      try {
        const base = new URL(API_URL);
        const target = new URL(url, window.location.origin);
        sameApiOrigin = target.origin === base.origin;
      } catch (_e) {
        sameApiOrigin = false;
      }
    }
    if (sameApiOrigin) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch (_e) {
    // never let header wiring break a request
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;
    console.error(
      `[API Error] ${config?.method?.toUpperCase()} ${config?.url} → ${response?.status || "network error"}`,
      response?.data || error.message
    );
    return Promise.reject(error);
  }
);
